import InfoIcon from '@mui/icons-material/Info';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import IconTitleText from '/@/components/crop-monitoring/icon-title-text';
import ModalTechnology from '/@/components/crop-monitoring/modal-technology';
import styles from '/@/components/technology-slider/styles.module.css';
import { _ } from '/@/locale';
import { reverse } from '/@/utils/router';

const BayerRecommendation = ({ isMobile, cropMonitoring, productsData }) => {
    const history = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = productsData.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    const handleClick = (e) => {
        history(
            reverse('catalog.ProductDetail', {
                params: {
                    type: 'crop_protection',
                    itemId: e.product.id,
                },
            })
        );
    };

    return (
        <Grid
            container
            justifyContent={!isMobile ? 'flex start' : 'center'}
            sx={{
                boxShadow: { md: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px' },
                borderRadius: 4,
                padding: 3,
                paddingBottom: 0,
            }}
        >
            <Grid item sx={{ height: { lg: 'fit-content' } }} xs={12}>
                <IconTitleText
                    icon={<InfoIcon sx={{ fontSize: 24 }} />}
                    title={`${_('Recomendaciones de Bayer')}`}
                    card
                />
            </Grid>
            <Grid
                item
                sx={{
                    width: '100%',
                    mb: 2,
                    borderRadius: 4,
                    position: 'relative',
                }}
            >
                {isMobile || productsData.length === 1 ? (
                    <Grid
                        container
                        direction='column'
                        sx={{
                            pt: { xs: 5, md: 0 },
                            maxWidth: 350,
                            height: { xs: 'auto', md: '350px' },
                            margin: 'auto',
                            alignItems: 'center',
                        }}
                    >
                        {productsData.map((s) => {
                            return (
                                <Grid item key={s.id} sx={{ py: 2, margin: 'auto' }}>
                                    <Grid sx={{ p: 2, border: '0.5px solid #E1E1E1', borderRadius: 4 }}>
                                        <ModalTechnology
                                            image={s.product.image}
                                            pills={{ type: s.product.type, crops: s.product.crops }}
                                            name={s.product.name}
                                            btnText={_('Ver más')}
                                            state='present'
                                            click={() => handleClick(s)}
                                            card
                                        />
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </Grid>
                ) : (
                    <Grid container justifyContent='center' alignItems='center' sx={{ height: '350px' }}>
                        <Grid item>
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    margin: 'auto',
                                    maxWidth: { sm: 350, lg: 400 },
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <div
                                        style={{ margin: '10px' }}
                                        onClick={activeStep !== 0 ? handleBack : null}
                                        className={activeStep === 0 ? styles.disabled : styles.notDisabled}
                                    >
                                        <span className='material-icons'>arrow_back</span>
                                    </div>
                                    <SwipeableViews
                                        axis='x'
                                        index={activeStep}
                                        onChangeIndex={handleStepChange}
                                        enableMouseEvents
                                        interval={8000}
                                    >
                                        {productsData.map((s) => {
                                            return (
                                                <Box sx={{ py: 2 }}>
                                                    <Grid
                                                        sx={{
                                                            p: 2,
                                                            border: '0.5px solid #E1E1E1',
                                                            borderRadius: 4,
                                                        }}
                                                    >
                                                        <ModalTechnology
                                                            image={s.product.image}
                                                            pills={{ type: s.product.type, crops: s.product.crops }}
                                                            name={s.product.name}
                                                            btnText={_('Ver más')}
                                                            state='present'
                                                            click={() => handleClick(s)}
                                                            card
                                                        />
                                                    </Grid>
                                                </Box>
                                            );
                                        })}
                                    </SwipeableViews>
                                    <div
                                        style={{ margin: '10px' }}
                                        onClick={activeStep !== maxSteps - 1 ? handleNext : null}
                                        className={activeStep === maxSteps - 1 ? styles.disabled : styles.notDisabled}
                                    >
                                        <span className='material-icons'>arrow_forward</span>
                                    </div>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};

export default BayerRecommendation;
